import { CHANGE_USER_CONTROL_PROPS } from "../actions/ActionConstants";

const initialState = {
	userControlList: [],
	userControl: null,
	loadingText: "Cargando...",
	busquedaRealizada: true,
	searchtext: "",
	modeCRU: "",
	activeFilters: false,
	page: 1,
	total: 0
};

export default function userControlReducer(state = initialState, action) {
	switch (action.type) {
		case CHANGE_USER_CONTROL_PROPS:
			return Object.assign({}, state, action.props);
		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/UserControlReducer.js